import { render, staticRenderFns } from "./WholesaleCompanyExpand.vue?vue&type=template&id=3f7f0a65&"
import script from "./WholesaleCompanyExpand.vue?vue&type=script&lang=js&"
export * from "./WholesaleCompanyExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/WholesaleCompanyExpand.vue
// module id = null
// module chunks = 